
export type DataType = 'STRING' | 'IMAGE' | 'VIDEO' | 'GEN_IMAGE' | 'GEN_VIDEO';

export interface NodeInput {
  key: string;
  type: DataType;
  label: string;
  maxConnections?: number; // Default: 1. Use -1 for infinite.
}

export interface NodeOutput {
  key: string;
  type: DataType;
  label: string;
}

export interface NodeDefinition {
  type: string;
  label: string;
  inputs: NodeInput[];
  outputs: NodeOutput[];
  canDelete: boolean;
  canCopy: boolean;
  defaultData?: Record<string, any>;
  width?: number; // Optional initial width
  height?: number; // Optional initial height
  resizable?: boolean; // New property for resizing capability
  isGroup?: boolean; // Mark as group node
}

export const DATA_TYPE_COLORS: Record<DataType, string> = {
  STRING: 'bg-yellow-400',
  IMAGE: 'bg-blue-500',
  VIDEO: 'bg-purple-500',
  GEN_IMAGE: 'bg-cyan-400',   // Light Blue for Image Tasks
  GEN_VIDEO: 'bg-fuchsia-400', // Pink/Magenta for Video Tasks
};